import type { SubscriptionInvoice } from "./types/subscriptions.types";

/**
 * What the Plan column says: what was bought, and for how long.
 *
 * Two facts joined by a middot — "Naurist Pro · 1 month" — because a prepaid
 * history is a list of separate purchases and not one plan charged over and
 * over. Without the term, two rows a year apart read as the same thing bought
 * twice; with it, one of them is plainly the year.
 *
 * Either half may be missing, and a row that carries neither gets an em dash
 * rather than a stray separator. The term is left off where the name already
 * carries it — the one-off internal grants are named "Internal access, 1 month
 * (one-time)", and "… (one-time) · 1 month" is the same month said twice.
 */
export const planLine = (invoice: SubscriptionInvoice): string => {
  const name = invoice.planName?.trim() ?? "";
  const duration = invoice.planDuration?.trim() ?? "";

  if (!name) return duration || "—";
  if (!duration || name.toLowerCase().includes(duration.toLowerCase())) {
    return name;
  }

  return `${name} · ${duration}`;
};
